import {
  createStaff,
  deleteStaff,
  fetchStaffById,
  fetchStaffListAll,
  updateStaff,
  fetchAllSecurityListOfStaff,
  fetchStaffListAllActive,
  fetchJudgeListAll,
} from "@/apis/staff/staffApi";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  activeList: [],
  current: null,
  listLoading: false,
  currentLoading: false,
  saving: false,
  deleting: false,
  showStaff: false,
  securityList: [],
  securityRulesFunctionality: [],
  securityRulesRecords: [],
  securityRulesCriteria: [],
  clientParams: [],
  judgeList: [],
};

const slice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    clearCurrentStaff(state) {
      state.current = null;
    },
    clearStaffSecurityList(state) {
      state.securityList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch all
      .addCase(fetchStaffListAll.pending, (s) => {
        s.listLoading = true;
      })
      .addCase(fetchStaffListAll.fulfilled, (s, a) => {
        s.list = a.payload;
        s.listLoading = false;
      })
      .addCase(fetchStaffListAll.rejected, (s) => {
        s.listLoading = false;
      })
      .addCase(fetchStaffListAllActive.pending, (s) => {
        s.listLoading = true;
      })
      .addCase(fetchStaffListAllActive.fulfilled, (s, a) => {
        s.activeList = a.payload;
        s.listLoading = false;
      })
      .addCase(fetchStaffListAllActive.rejected, (s) => {
        s.listLoading = false;
      })
      // fetch by id
      .addCase(fetchStaffById.pending, (s) => {
        s.currentLoading = true;
      })
      .addCase(fetchStaffById.fulfilled, (s, a) => {
        s.current = a.payload;
        s.currentLoading = false;
      })
      .addCase(fetchStaffById.rejected, (s) => {
        s.currentLoading = false;
      })

      // create
      .addCase(createStaff.pending, (s) => {
        s.saving = true;
      })
      .addCase(createStaff.fulfilled, (s, a) => {
        s.list.push(a.payload);
        s.saving = false;
      })
      .addCase(createStaff.rejected, (s) => {
        s.saving = false;
      })

      // update
      .addCase(updateStaff.pending, (s) => {
        s.saving = true;
      })
      .addCase(updateStaff.fulfilled, (s, a) => {
        s.list = s?.list?.map((c) =>
          c.securityRulesCriteriaID === a?.payload?.securityRulesCriteriaID
            ? a?.payload
            : c
        );
        s.current = a?.payload;
        s.saving = false;
      })
      .addCase(updateStaff.rejected, (s) => {
        s.saving = false;
      })

      // delete
      .addCase(deleteStaff.pending, (s) => {
        s.deleting = true;
      })
      .addCase(deleteStaff.fulfilled, (s, a) => {
        s.list = s?.list?.filter(
          (c) => c?.securityRulesCriteriaID !== a?.payload
        );
        if (s?.current?.securityRulesCriteriaID === a?.payload) {
          s.current = null;
        }
        s.deleting = false;
      })
      .addCase(deleteStaff.rejected, (s) => {
        s.deleting = false;
      })

      .addCase(fetchAllSecurityListOfStaff.pending, (s) => {
        // s.deleting = true;
      })
      .addCase(fetchAllSecurityListOfStaff.fulfilled, (s, a) => {
        s.securityList = a.payload?.data;
      })
      .addCase(fetchAllSecurityListOfStaff.rejected, (s) => {
        // s.deleting = false;
      })

      .addCase(fetchJudgeListAll.pending, (s) => {
        s.listLoading = true;
      })
      .addCase(fetchJudgeListAll.fulfilled, (s, a) => {
        s.judgeList = a.payload;
        s.listLoading = false;
      })
      .addCase(fetchJudgeListAll.rejected, (s) => {
        s.listLoading = false;
      });
  },
});

export const { clearCurrentStaff, clearStaffSecurityList } = slice.actions;
export default slice.reducer;
